export default __webpack_public_path__ + "static/media/checkbox.fa0ac82e.svg";